import * as R from 'ramda';


/**
 * Returns the possessive form of the provided noun, placing the apostrophe after the noun and an 's' if needed.
 * The noun can be multiple words, e.g. John Smith -> John Smith's
 * @param noun - The noun that the possessive apostrophe is being appended
 */
export const apostrophize = (noun: string) => {
  const lastLetter = noun.slice(-1);

  if (lastLetter === 's') {
    return `${noun}'`;
  }

  return `${noun}'s`;
};


/**
 * A better toString method that avoids the whole `[object Object]` problem. Arrays will toString
 * as themselves, objects will produce JSON, strings will map back to themselves.
 *
 * @example
 *      R.toString(42); //=> '42'
 *      R.toString('abc'); //=> 'abc'
 *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
 *      R.toString(['1', '2', '3']); //=> '["1", "2", "3"]'
 *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
 *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
 */
export const makeString = value => {
  // R.toString puts quotes on strings... XP
  if (typeof value === 'string') {
    return value;
  }

  return R.toString(value);
};
